import React, { useContext } from 'react'
import { Box, Input } from '@postenbring/hedwig-react'
import { InternationalCalculatorContext } from '../../InternationalCalculatorContext'
import { useCountryInputHandlers } from '../hooks/useCountryInputHandlers'
import { useCountryFetcher } from '../hooks/useCountryFetcher'

export const CountryDropdown = ({ labels, serviceUrlCountries }) => {
  const {
    countryQuery,
    filteredCountries,
    showDropdown,
    highlightedIndex,
    errorSelect,
    countries,
    setFilteredCountries,
    setShowDropdown,
    setHighlightedIndex,
    setDestination,
    setCountryQuery,
    setErrorSelect,
    setErrorInputPostalCode,
    setInputError,
    setCountries
  } = useContext(InternationalCalculatorContext)

   // Fetch countries once when the dropdown mounts
   useCountryFetcher(serviceUrlCountries, setCountries)

  const handleCountrySelect = (country) => {
    setCountryQuery(country.label)
    setDestination(country.value)
    setFilteredCountries([])
    setShowDropdown(false)
    setHighlightedIndex(-1)
    setErrorSelect(null)
    setErrorInputPostalCode(null)
    setInputError(null)
  }

  const {
    handleCountryInputChange,
    handleInputFocus,
    handleKeyDown
  } = useCountryInputHandlers({
    countries,
    setFilteredCountries,
    setShowDropdown,
    setHighlightedIndex,
    setDestination,
    setCountryQuery,
    setErrorSelect,
    setErrorInputPostalCode,
    setInputError,
    filteredCountries,
    highlightedIndex,
    handleCountrySelect
  })

  return (
    <Box style={{ width: "50%", padding: "0px", position: "relative" }} className="country-dropdown">
      <Input
        errorMessage={errorSelect}
        autoComplete="off"
        label={labels.destinationPriceZone}
        value={countryQuery}
        onChange={handleCountryInputChange}
        onFocus={handleInputFocus}
        onKeyDown={handleKeyDown}
      />
      {showDropdown && filteredCountries.length > 0 && (
        <Box
          style={{
            position: "absolute",
            width: "100%",
            background: "white",
            border: "1px solid #ccc",
            boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
            zIndex: 10,
            maxHeight: "250px",
            overflowY: "auto",
            padding: "0px"
          }}
        >
          {filteredCountries.map((country, index) => (
            <Box
              key={country.value}
              style={{
                padding: "8px",
                cursor: "pointer",
                backgroundColor: highlightedIndex === index ? "#f0f0f0" : "white"
              }}
              onClick={() => handleCountrySelect(country)}
            >
              {country.label}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  )
}